/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Detect_Illegal_Netflix_LabelInputs */



/**
* | output |
* | --- |
* | "Detect Illegal Characters (Netflix)" |
*
* @param {Style_Guide_Manager_Detect_Illegal_Netflix_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_detect_illegal_netflix_label = /** @type {((inputs?: Style_Guide_Manager_Detect_Illegal_Netflix_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Detect_Illegal_Netflix_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Detecter les caracteres illegaux (Netflix)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erkennung illegaler Zeichen (Netflix)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rileva personaggi illegali (Netflix)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обнаружение недопустимых символов (Netflix)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Detectar personajes ilegales (Netflix)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("检测非法字符（Netflix）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("不正な文字を検出する（Netflix）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अवैध वर्णों का पता लगाएं (नेटफ्लिक्स)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Detectar caracteres ilegais (Netflix)")
	return /** @type {LocalizedString} */ ("Detect Illegal Characters (Netflix)")
});